import { defineComponent as _defineComponent } from 'vue';
import { BCard, BCardHeader, BCardBody } from 'bootstrap-vue';
import { getVisualisationUrl } from 'public/modules/frameDesigner';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FrameDesignOption',
    props: {
        frameSize: { default: null },
        itemSize: null,
        lengthSku: null,
        mount: null,
        fromPrice: null,
        selected: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const description = computed(() => props.frameSize
            ? `${props.frameSize.name} to fit ${props.itemSize.name} item`
            : `${props.itemSize.name} (No Mount)`);
        const rebateSize = computed(() => props.frameSize
            ? {
                width: Math.min(props.frameSize.width, props.frameSize.length) + 3,
                length: Math.max(props.frameSize.width, props.frameSize.length) + 3
            }
            : {
                width: Math.min(props.itemSize.width, props.itemSize.length) + 3,
                length: Math.max(props.itemSize.width, props.itemSize.length) + 3
            });
        const apertureSize = computed(() => ({
            width: Math.min(props.itemSize.width, props.itemSize.length) - 6,
            length: Math.max(props.itemSize.width, props.itemSize.length) - 6
        }));
        const mountBorders = computed(() => {
            if (props.frameSize) {
                const yBorder = ((rebateSize.value.length - apertureSize.value.length) - 3) / 2;
                const xBorder = ((rebateSize.value.width - apertureSize.value.width) - 3) / 2;
                return {
                    type: 'single',
                    top: props.mount,
                    bottom: null,
                    reveal: 0,
                    borders: { top: yBorder, bottom: yBorder, left: xBorder, right: xBorder }
                };
            }
            return {
                type: 'none',
                top: null,
                bottom: null,
                reveal: 0,
                borders: { top: 0, bottom: 0, left: 0, right: 0 }
            };
        });
        const imgSrc = computed(() => getVisualisationUrl(props.lengthSku, rebateSize.value, apertureSize.value, mountBorders.value, true, null, 1));
        const altText = '#';
        return { __sfc: true, props, description, rebateSize, apertureSize, mountBorders, imgSrc, altText, BCard, BCardHeader, BCardBody, getVisualisationUrl, computed };
    }
});
